var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27211 2.40618C9.43303 2.04412 9.36501 1.62119 9.09868 1.32785C8.83236 1.0345 8.41795 0.926062 8.04207 1.05135C6.58977 1.53545 5.43115 2.4875 4.36952 3.54913C-0.123172 8.04182 -0.123172 15.2385 4.36952 19.7312C8.88809 24.2497 15.8801 23.9923 20.3464 19.526C21.408 18.4644 22.3601 17.3057 22.8442 15.8534C22.9658 15.4887 22.8675 15.0867 22.5915 14.8191C22.3155 14.5516 21.9105 14.466 21.5498 14.5988C17.9597 15.9215 13.8754 15.3328 11.1165 12.5739C8.35091 9.8083 7.78844 5.74444 9.27211 2.40618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeWhite);
export default __webpack_public_path__ + "static/media/dark-mode-white.87a588781398dbafd82da900707a99a0.svg";
export { ForwardRef as ReactComponent };